import { createReducer, createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
    openMenu: null,
    closeMenu: null
}, {})


export const menuTypes = Types;
export default Creators;

const _openMenu = () => {
    return { menuOpen: true }
}
const closeMenu = () => ({ menuOpen: false })

const INITIAL = { menuOpen: true }
export const reducer = createReducer(INITIAL, {
    [Types.OPEN_MENU]: _openMenu,
    [Types.CLOSE_MENU]: closeMenu,
});


// WEBPACK FOOTER //
// ./src/redux/sidemenuStore.js